import React from 'react';

export const Chainloop = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 88.45 88.45"
      {...props}
    >
      <defs>
        <clipPath id="clip-path">
          <circle cx="44.22" cy="44.22" r="36.5" fill="none" />
        </clipPath>
      </defs>
      <circle
        cx="44.22"
        cy="44.22"
        r="43.5"
        stroke="#27375f"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="#fff"
        stroke-width="1.45"
      />
      <text
        font-size="11px"
        fill=" #010101"
        font-family="Lato-Bold,Lato"
        font-weight="700"
        transform="rotate(56.78 -51.926 40.628)"
      >
        C
      </text>
      <text
        font-size="11px"
        fill=" #010101"
        font-family="Lato-Bold,Lato"
        font-weight="700"
        transform="rotate(41.4 -84.432 56.3)"
      >
        H
      </text>
      <text
        font-size="11px"
        fill=" #010101"
        font-family="Lato-Bold,Lato"
        font-weight="700"
        transform="rotate(25.8 -153.653 90.126)"
      >
        A
      </text>
      <text
        font-size="11px"
        fill=" #010101"
        font-family="Lato-Bold,Lato"
        font-weight="700"
        transform="rotate(14.21 -306.372 173.964)"
      >
        I
      </text>
      <text
        font-size="11px"
        fill=" #010101"
        font-family="Lato-Bold,Lato"
        font-weight="700"
        transform="translate(38.68 81.92)"
      >
        N
      </text>
      <text
        font-size="11px"
        fill=" #010101"
        font-family="Lato-Bold,Lato"
        font-weight="700"
        transform="rotate(-11.52 430.619 -202.97)"
      >
        L
      </text>
      <text
        font-size="11px"
        fill=" #010101"
        font-family="Lato-Bold,Lato"
        font-weight="700"
        transform="rotate(-25.16 208.382 -86.463)"
      >
        O
      </text>
      <text
        font-size="11px"
        fill=" #010101"
        font-family="Lato-Bold,Lato"
        font-weight="700"
        transform="rotate(-42.1 131.07 -48.88)"
      >
        O
      </text>
      <text
        font-size="11px"
        fill=" #010101"
        font-family="Lato-Bold,Lato"
        font-weight="700"
        transform="rotate(-57.3 99.18 -34.437)"
      >
        P
      </text>
      <g clip-path="url(#chainloop-clip-path)">
        <path
          d="M45-11.06c6.06 17.84 22.3 71.28-1 71.28-24.47 0-6.92-58.84-2.12-73.65"
          stroke-width="2"
          stroke-dasharray="2.03 5.07"
          stroke="#27375f"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
      </g>
    </svg>
  );
};
